<template>
  <v-switch
    v-bind="{
      ...$props,
      ...$attrs,
    }"
    v-model="inputVal"
    inset
    density="compact"
    :label="label"
    :ripple="false"
    @click="click($event)"
  />
</template>
<script>
export default {
  props: {
    alt: Boolean,
    preventDefault: Boolean,
    borderColor: { type: String, default: '#4181c3' },
    label: { type: String, default: '' },
    modelValue: { type: Boolean, default: false },
  },
  emits: ['update:model-value'],
  computed: {
    inputVal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:model-value', val);
      },
    },
  },
  methods: {
    click(e) {
      if (this.preventDefault) {
        e.preventDefault();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.v-input :deep(.v-switch__track) {
  background-color: @text-darkest;
  opacity: 1;
  height: 22px !important;
  width: 44px !important;
}

.v-input :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: @text-brand;
}

.v-input :deep(.v-switch__thumb) {
  background-color: white;
}
.v-input :deep(.v-label) {
  color: @text-darkest!important;
  font-size: 16px;
  font-weight: 400;
  width: auto;
  max-width: 55px;
  opacity: 1;
}
.v-input :deep(.v-selection-control--dirty .v-label) {
  color: @text-brand!important;
}
.v-input :deep(.v-selection-control__input) {
  margin-right: 0!important;
}
.v-switch.v-input--is-dirty.v-input--is-disabled {
  opacity: 1;
}
.v-input.v-input--is-disabled :deep(.v-switch__track) {
    color: @text-darkest;
    opacity: .2 !important;
    pointer-events: none;
}

// This seems to break alignment, turning it off
.v-switch.v-input--horizontal {
  grid-template-areas: unset;
}

.v-input.v-switch--inset :deep(.v-switch__track) {
  height: 20px;
  width: 40px;
  min-width: 40px;
}

.v-input.v-switch--inset :deep(.v-switch__thumb) {
  height: 18px;
  width: 18px;
  transform: unset;
  --webkit-transform: unset;
}
</style>
